import superagent from 'superagent';

const URL = '/lm/v1/skinbuilder';

// Builds and signs the APK server-side, then streams the signed apk back as a blob.
// fields: { brand, vendor, factory, ram, term_condition?, brand_logo?: File, about_us?: File, term_condition_html?: File }
// brand_logo/about_us/term_condition are all optional — the script skips whatever isn't
// supplied. brandLogoVisible is derived server-side from whether brand_logo was sent.
export const buildApk = (fields, callback) => {
    var request = superagent.post(URL + '/apk')
        .field('brand', fields.brand)
        .field('vendor', fields.vendor)
        .field('factory', fields.factory)
        .field('ram', fields.ram);

    if (fields.term_condition) {
        request = request.field('term_condition', fields.term_condition);
    }

    if (fields.brand_logo) {
        request = request.attach('brand_logo', fields.brand_logo, fields.brand_logo.name);
    }

    if (fields.about_us) {
        request = request.attach('about_us', fields.about_us, fields.about_us.name);
    }

    if (fields.term_condition_html) {
        request = request.attach('term_condition_html', fields.term_condition_html, fields.term_condition_html.name);
    }

    request
        .responseType('blob')
        .end((err, response) => {
            if (err) {
                if (response && response.body instanceof Blob) {
                    var reader = new FileReader();
                    reader.onload = () => {
                        var message = 'Failed to build APK. Try again';
                        try {
                            var parsed = JSON.parse(reader.result);
                            message = parsed.message || message;
                        } catch (e) {
                            console.log('Could not parse error response', e);
                        }
                        callback({ ok: false, message: message });
                    };
                    reader.onerror = () => callback({ ok: false, message: 'Failed to build APK. Try again' });
                    reader.readAsText(response.body);
                } else {
                    console.log('Request failed', err);
                    callback({ ok: false, message: 'Failed to build APK. Try again' });
                }
                return;
            }
            var disposition = (response.headers && response.headers['content-disposition']) || '';
            var match = disposition.match(/filename="?([^"]+)"?/);
            var buildInfo = null;
            var buildInfoHeader = response.headers && response.headers['x-skin-build-info'];
            if (buildInfoHeader) {
                try {
                    buildInfo = JSON.parse(decodeURIComponent(buildInfoHeader));
                } catch (e) {
                    console.log('Could not parse build info header', e);
                }
            }
            callback({ ok: true, blob: response.body, filename: match ? match[1] : 'skin.apk', buildInfo: buildInfo });
        });
};
